import $ from 'jquery';

import createOption from './createOption';
import wording from '../wording';

const setWorknoSelectBoxOption = (list) => {
	$('#api-WORKNO').find('option').remove();
	if (list.length) {
		$('.field[data-rel="apiWORKNO"]').removeClass('-hide');
		$('#password-login-button').removeClass('-disable');

		list.forEach((listData) => {
			$('#api-WORKNO').append(createOption(listData.WORKNO));
		});

		return;
	}

	$('.message-box').addClass('-warning');
	$('.message-box').text(wording.NOWORKNO);
	$('#password-login-button').addClass('-disable');
};

export default setWorknoSelectBoxOption;



// WEBPACK FOOTER //
// ./src/js/index/setWorknoSelectBoxOption.js